import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import EmailIcon from '@components/icons/Email.svg';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { normalizeEmail } from '@helpers/normalizeEmail';
import { useAPI } from '@providers/useAPI';
import { AdminService } from 'app/API';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

import { Content } from './styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  id: string;
  email: string;
};

export const AdminEditUserEmailModal = ({ onCancel, onSuccess, id, email }: TProps) => {
  const { call } = useAPI();
  const [newEmail, setNewEmail] = useState(email);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    let requestErrorMessage: string | undefined;
    try {
      await call(() => AdminService.updateUserEmail({ userId: id, requestBody: { email: normalizeEmail(newEmail) } }), {
        onError: (message) => {
          requestErrorMessage = message;
        },
      });
      onSuccess();
    } catch {
      toast.error(requestErrorMessage || 'Could not update the email.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalWrapper width="300px">
      <ModalTitle>Edit User Email</ModalTitle>
      <Content>
        <form action="#" onSubmit={submit}>
          <div className="inputWrapper">
            <Input
              icon={EmailIcon}
              required
              value={newEmail}
              type="email"
              label="Email"
              name="email"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewEmail(e.target.value)}
              error={isSubmitting && !newEmail}
            />
          </div>
          <div className="buttonWrapper">
            <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
            <Button type="submit" disabled={!newEmail.length}>
              Save
            </Button>
          </div>
        </form>
      </Content>
    </ModalWrapper>
  );
};
